import {
  VStack,
  HStack,
  Image,
  NextLink,
  customEvent,
  colors,
  Spacing,
} from "goi_common";
import { Box } from "@chakra-ui/react";
import { prPress } from "@/constants/prPress";
import styled from "@emotion/styled";

export default function HomeV4PRSection() {
  return (
    <VStack width="100%" padding="80px 20px" gap={24}>
      <Box className="head_24_b gray900">
        언론에서 주목한
        <br />
        고이의 모습을 확인해 보세요
      </Box>

      <SliderContainer>
        <SliderTrack
          onClick={() => {
            customEvent({
              newGtm: {
                path: "home",
                trigger_and_target: "pr-uv_pr",
              },
            });
          }}
        >
          {prPress.slice(0, 10).map((pr, i) => (
            <PressCard
              key={`pr-${i}`}
              src={pr.imgSrc}
              title={pr.title}
              press={pr.press}
              date={pr.date}
              href={pr.href}
            />
          ))}
        </SliderTrack>
      </SliderContainer>
    </VStack>
  );
}

interface PressCardProps {
  src: string;
  title: string;
  press: string;
  date: string;
  href: string;
}

function PressCard({ src, title, press, date, href }: PressCardProps) {
  return (
    <NextLink href={href}>
      <VStack
        width="260px"
        background={colors.white}
        borderRadius="6px"
        overflow="hidden"
        border={`1px solid ${colors.gray200}`}
      >
        <Box
          width="100%"
          height="180px"
          overflow="hidden"
          css={{
            "& img": {
              width: "100%",
              height: "100%",
              objectFit: "cover",
            },
          }}
        >
          <Image src={src} width="100%" height="180px" alt={title} />
        </Box>
        <VStack padding="20px">
          <Box
            className="subtitle_16_sb gray900"
            css={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              lineHeight: "1.4",
            }}
          >
            {title}
          </Box>
          <Spacing gap={20} />
          <HStack gap={8} className="caption_12_r gray500">
            <span>{press}</span>
            <span>|</span>
            <span>{date}</span>
          </HStack>
        </VStack>
      </VStack>
    </NextLink>
  );
}

const SliderContainer = styled.div`
  width: 100%;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 20px;
  padding-right: 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const SliderTrack = styled.div`
  display: flex;
  gap: 12px;
  width: fit-content;
  padding-right: 20px;
`;
